var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLock = function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D3F7EF",
    fillRule: "evenodd",
    d: "M17.43 1.887a3.637 3.637 0 0 1 5.155-.032l7.34 7.256.01.01 8.21 8.383a3.7 3.7 0 0 1 1.055 2.59v17.82c0 2.036-1.637 3.686-3.657 3.686H4.457C2.437 41.6.8 39.95.8 37.914v-17.8a3.7 3.7 0 0 1 1.087-2.622L10.3 9.117z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#009E7B",
    fillRule: "evenodd",
    d: "M14 23.8v-2.4a6 6 0 0 1 12 0v2.4a2.4 2.4 0 0 1 2.4 2.4v6a2.4 2.4 0 0 1-2.4 2.4H14a2.4 2.4 0 0 1-2.4-2.4v-6a2.4 2.4 0 0 1 2.4-2.4m9.6-2.4v2.4h-7.2v-2.4a3.6 3.6 0 0 1 7.2 0",
    clipRule: "evenodd"
  })));
};
export default SvgLock;